// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Search_search__9Rems {
  width: 55rem;
  border-radius: 5rem;
  background-color: var(--gray-extra-light);
  padding: 1rem 3rem;
}

.Search_search__filter__2drSq {
  gap: 0.5rem;
}

.Search_search__filter-text__KSCOP {
  font-size: var(--text-base);
  font-weight: 500;
}

.Search_search__line__0PJBh {
  flex-shrink: 0;
  height: 40px;
  width: 1px;
  background-color: #000;
  margin-inline: 2rem 2rem;
}

.Search_search__input__xBAsP {
  font-size: var(--text-base);
  font-weight: 500;
  color: var(--gray-extra-dark);
  background-color: var(--gray-extra-light);
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .Search_search__9Rems {
    width: 45rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/DashboardHeader/Searchbar/Search/Search.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".search {\n  width: 55rem;\n  border-radius: 5rem;\n  background-color: var(--gray-extra-light);\n  padding: 1rem 3rem;\n}\n\n.search__filter {\n  gap: 0.5rem;\n}\n\n.search__filter-text {\n  font-size: var(--text-base);\n  font-weight: 500;\n}\n\n.search__line {\n  flex-shrink: 0;\n  height: 40px;\n  width: 1px;\n  background-color: #000;\n  margin-inline: 2rem 2rem;\n}\n\n.search__input {\n  font-size: var(--text-base);\n  font-weight: 500;\n  color: var(--gray-extra-dark);\n  background-color: var(--gray-extra-light);\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1280px) {\n  .search {\n    width: 45rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search": `Search_search__9Rems`,
	"search__filter": `Search_search__filter__2drSq`,
	"search__filter-text": `Search_search__filter-text__KSCOP`,
	"search__line": `Search_search__line__0PJBh`,
	"search__input": `Search_search__input__xBAsP`
};
export default ___CSS_LOADER_EXPORT___;
